(ns minorodata.connections.subs
  (:require
   [clojure.string]
   [minorodata.app.semver :as app.semver]
   [minorodata.app.utils :as app.utils]
   [minorodata.connections.list :as connections-list]
   [minorodata.utils :as utils]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]))


(re-frame/reg-sub
 :connections.subs/schemas
 (fn [db _]
   (get-in db [:source-metadata :schemas])))

(re-frame/reg-sub
 :connections.subs/tables
 (fn [db _]
   (get-in db [:source-metadata :tables])))

(re-frame/reg-sub
 :connections.subs/columns
 (fn [db _]
   (get-in db [:source-metadata :columns])))

(re-frame/reg-sub
 :connections.subs/primary-keys
 (fn [db _]
   (get-in db [:source-metadata :primary-keys])))




(re-frame/reg-sub
 :connections.subs/database-schemas
 :<- [:connections.subs/schemas]
 (fn [metadata [_ fields]]
   (let [source-id (get-in fields [:source-id :value])]
     (sort (get metadata source-id)))))


(re-frame/reg-sub
 :connections.subs/database-tables
 :<- [:connections.subs/tables]
 (fn [metadata [_ fields]]
   (let [source-id        (get-in fields [:source-id :value])
         schema           (get-in fields [:source-schema :value])]
     (->> (get-in metadata [source-id schema])
          (map :table-name)
          (sort)))))


(re-frame/reg-sub
 :connections.subs/database-columns
 :<- [:connections.subs/columns]
 (fn [metadata [_ fields]]
   (let [source-id         (get-in fields [:source-id :value])
         schema            (get-in fields [:source-schema :value])
         table             (get-in fields [:source-table :value])

         available-columns (get-in metadata [source-id schema table])
         sorted-columns    (sort-by :ordinal-position available-columns)]
     (map :column-name sorted-columns))))


(re-frame/reg-sub
 :connections.subs/all-database-columns
 :<- [:connections.subs/columns]
 (fn [metadata [_ {:keys [source-id schema table]}]]
   (let [available-columns (get-in metadata [source-id schema table])
         sorted-columns    (sort-by :ordinal-position available-columns)]
     (map :column-name sorted-columns))))



(re-frame/reg-sub
 :connections.subs/database-columns-with-pk-marker
 :<- [:connections.subs/columns]
 :<- [:connections.subs/primary-keys]
 (fn [[metadata primary-keys-metadata] [_ fields]]
   (let [source-id         (get-in fields [:source-id :value])
         schema            (get-in fields [:source-schema :value])
         table             (get-in fields [:source-table :value])

         primary-keys      (get-in primary-keys-metadata [source-id schema table])
         available-columns (get-in metadata [source-id schema table])
         sorted-columns    (sort-by :ordinal-position available-columns)

         columns           (map :column-name sorted-columns)
         pkeys             (set (map :column-name primary-keys))]

     (map (fn [col]
            (let [name (if (contains? pkeys col)
                         (str col " (PRIMARY KEY)")
                         col)]
              {:value col :name name}))
          columns))))


(defn- newest-by-master-id
  "Indexes extracts by master-id, keeping only the most recently updated
   revision of each — old + new revisions of the same master-id can transiently
   coexist (that's the whole reason stale-master-id-deletes exists), and picking
   an arbitrary match risks resolving to a dead extract-id."
  [extracts]
  (->> extracts
       (filter #(some? (:extract/master-id %)))
       (group-by :extract/master-id)
       (reduce-kv (fn [index master-id revisions]
                    (assoc index master-id
                           (apply max-key #(or (:extract/updated-at %) "") revisions)))
                  {})))

(re-frame/reg-sub
 :connections.subs/extract-by-master-id-index
 :<- [:extract/pull-many]
 (fn [extracts _]
   (newest-by-master-id extracts)))

(re-frame/reg-sub
 :connections.subs/extract-by-master-id
 :<- [:connections.subs/extract-by-master-id-index]
 (fn [index [_ master-id]]
   (get index master-id)))

(re-frame/reg-sub
 :connections.subs/active-extract-id
 :<- [:connections.subs/extract-by-master-id-index]
 (fn [index [_ master-id]]
   (:extract/extract-id (get index master-id))))

(re-frame/reg-sub
 :connections.subs/database-columns-with-metadata
 :<- [:connections.subs/columns]
 (fn [metadata [_ fields]]
   (let [source-id         (get-in fields [:source-id :value])
         schema            (get-in fields [:source-schema :value])
         table             (get-in fields [:source-table :value])

         available-columns (get-in metadata [source-id schema table])
         sorted-columns    (sort-by :ordinal-position available-columns)]
     (map #(select-keys % [:type-name :column-name]) sorted-columns))))


(re-frame/reg-sub
 :connections.subs/database-primary-keys
 :<- [:connections.subs/primary-keys]
 (fn [metadata [_ fields]]
   (let [source-id    (get-in fields [:source-id :value])
         schema       (get-in fields [:source-schema :value])
         table        (get-in fields [:source-table :value])

         primary-keys (get-in metadata [source-id schema table])
         sorted-keys  (sort-by :key-seq primary-keys)]

     (map :column-name sorted-keys))))


(defn empty-form []
  {:format-for-api    (fn [] (println "NOT IMPLEMENTED"))
   :fromat-for-inputs (fn [] (println "NOT IMPLEMENTED"))
   :validate          (constantly nil)
   :id                (keyword (str (random-uuid)))
   :blocks            [{:content "NOT IMPLEMENTED"}]})


(defn coerce-values
  "Coerces certain block type values to better fit logic of the old material ui components, since a lot of jumper connectors depend on some of the non standard behaviours by material ui inputs."
  [data blocks]
  (reduce (fn [data' block]

            ;; Just one block type needs this for now. Material UI select used
            ;; to acceps :value fields of any type. Radix UI follows html spec
            ;; much closer and only works with strings.
            ;;
            ;; Some of our extracts depend on select values being integest, and 
            ;; sometimes being nil if None value is selected.

            (if (and (= :select (:block-type block))
                     (number? (:value (last (:options block)))))
              (let [old-value (get data' (:name block))
                    new-value (if (= "" old-value)
                                nil
                                (js/parseInt old-value))]
                (assoc data' (:name block) new-value))
              data'))
          data
          blocks))


(defn make-compatible-source [conn]
  (let [id         (:connector conn)
        form-id    (keyword (str id "-form"))
        version    (:version conn)
        source     (app.utils/try-reading-string (:source conn))
        blocks     (:blocks source)

        mq-enabled (get source :message-queue-enabled true)]
    {:format-for-api
     (fn [data]
       (let [{:keys [name description]} data
             clean-data   (dissoc data :name :description)
             coerced-data (coerce-values clean-data blocks)
             source-data  (assoc coerced-data :version version)]
         {:source-type id
          :name        name
          :description description
          :source      source-data}))

     :format-for-inputs
     (fn [data]
       (let [{:keys [source name description]} data]
         (merge {:name        name
                 :description description}
                source)))

     :validate              (constantly nil)

     :message-queue-enabled mq-enabled

     :id                    form-id
     :blocks                blocks}))


(defn make-compatible-extract [conn]
  (let [id                     (:connector conn)
        form-id                (keyword (str id "-extract-form"))
        version                (:version conn)
        extract                (app.utils/try-reading-string (:extract conn))
        blocks                 (:blocks extract)

        open-form-when-created (:open-form-when-created extract)]
    {:format-for-api
     (fn [data]
       (let [{:keys [name description status downstream-config destination-table]} data
             clean-data        (dissoc data :name :description :status :downstream-config)
             coerced-data      (coerce-values clean-data blocks)
             data-with-version (assoc coerced-data :version version)]

         {:name          name
          :description   (or description "")
          :status        status
          :output-tables [destination-table]
          :downstream-config (if (= downstream-config true) "full" nil)

          :config
          {:extracts [data-with-version]}}))

     :format-for-inputs
     (fn [data]
       (let [{:extract/keys [config description name source-id downstream-config status]} data

             extract (get-in config [:extracts 0])]
         (merge
          (app.utils/keep-non-nil-keys
           {:name          name
            :description   description
            :status        status
            :output-tables []
            :source-id     source-id
            :downstream-config (= downstream-config "full")})
          extract)))

     :validate               (constantly nil)

     :open-form-when-created open-form-when-created

     :id                     form-id
     :blocks                 blocks}))


(defn make-compatible-preview [conn]
  (let [preview (app.utils/try-reading-string (:preview conn))]
    (:blocks preview)))


(defn prepare-connector [conn]
  (let [preview (make-compatible-preview conn)
        source  (make-compatible-source conn)
        extract (make-compatible-extract conn)]
    (assoc conn
           :tags [(:tag conn)]
           :id (:connector conn)

           :form source
           :extract-form extract
           :preview-formatter preview

           :message-queue-enabled (get source :message-queue-enabled true)
           :open-form-when-created (:open-form-when-created extract))))


(defn keep-latest-connectors [connectors]
  (let [grouped (group-by :connector connectors)
        groups  (vals grouped)

        sorted  (map (fn [group]
                       (sort-by :version app.semver/compare group))
                     groups)]
    (map last sorted)))


(re-frame/reg-sub
 :connections.subs/prepared-user-connectors-all
 :<- [:user-connectors/prop :user-connectors/list]
 (fn [all-user-connectors _]
   (map prepare-connector all-user-connectors)))


(re-frame/reg-sub
 :connections.subs/prepared-user-connectors-enabled
 :<- [:user-connectors/prop :user-connectors/list]
 (fn [all-user-connectors _]
   (let [enabled-connectors  (filter :enabled all-user-connectors)]
     (map prepare-connector enabled-connectors))))


(re-frame/reg-sub
 :connections.subs/prepared-user-connectors-current
 :<- [:user-connectors/prop :user-connectors/list]
 (fn [all-user-connectors _]
   (let [enabled-connectors  (filter :enabled all-user-connectors)
         only-latest         (keep-latest-connectors enabled-connectors)]
     (map prepare-connector only-latest))))


(re-frame/reg-sub
 :connections.subs/prepared-user-connectors-current-unfiltered
 :<- [:user-connectors/prop :user-connectors/list]
 (fn [all-user-connectors _]
   (let [only-latest         (keep-latest-connectors all-user-connectors)]
     (map prepare-connector only-latest))))


(re-frame/reg-sub
 :connections.subs/current-connectors
 :<- [:connections.subs/prepared-user-connectors-current]
 (fn [jumper-connectors _]
   (concat connections-list/sources
           jumper-connectors)))

(re-frame/reg-sub
 :connections.subs/connector
 :<- [:connections.subs/current-connectors]
 (fn [connectors [_ type]]
   (utils/find-by-field connectors :id type)))


(re-frame/reg-sub
 :connections.subs/current-connectors-unfiltered
 :<- [:connections.subs/prepared-user-connectors-current-unfiltered]
 (fn [jumper-connectors _]
   (concat connections-list/sources
           jumper-connectors)))


(re-frame/reg-sub
 :connections.subs/all-connectors
 :<- [:connections.subs/prepared-user-connectors-all]
 (fn [jumper-connectors _]
   (concat connections-list/sources
           jumper-connectors)))


(re-frame/reg-sub
 :connections.subs/all-enabled-connectors
 :<- [:connections.subs/prepared-user-connectors-enabled]
 (fn [[jumper-connectors] _]
   (concat connections-list/sources
           jumper-connectors)))


(re-frame/reg-sub
 :connections.subs/app-admin-all-connectors
 :<- [:admin-data/prop :admin-data/connectors]
 (fn [connectors _]
   (concat connections-list/sources
           connectors)))


(re-posh/reg-query-sub
 :extract-eids-for-source-id
 '[:find [?eid ...]
   :in $ ?source-id
   :where [?eid :extract/source-id ?source-id]])

(re-posh/reg-pull-many-sub
 :extracts-for-eids
 '[* {:extract/updated-by [:searchable-user/username]
      :extract/created-by [:searchable-user/username]}])

(re-frame/reg-sub
 :connections.subs/extracts-for-source
 (fn [[_ source-id]]
   [(re-posh/subscribe [:extract-eids-for-source-id source-id])
    (re-posh/subscribe [:mold-http/loading? :connections.api/fetch-extracts])
    (re-posh/subscribe [:extract-job/pull-many])])
 (fn [[eids extracts-loading? jobs]]
   (let [extracts @(re-posh/subscribe [:extracts-for-eids eids])]
     {:extracts          extracts
      :extracts-loading? extracts-loading?
      :jobs              jobs})))

(re-frame/reg-sub
 :connections.subs/jobs-for-extract
 (fn []
   [(re-posh/subscribe [:extract-job/pull-many])])
 (fn [[jobs] [_ extract-id]]
   (filter #(= (:extract-job/extract %) extract-id)
           jobs)))

(re-frame/reg-sub
 :connections.subs/running-jobs-for-extract
 (fn [[_ extract-id]]
   [(re-posh/subscribe [:connections.subs/jobs-for-extract extract-id])])
 (fn [[jobs]]
   (filter #(= (:extract-job/status %) :running)
           jobs)))

(re-frame/reg-sub
 :connections.subs/sources-list-view
 (fn [_]
   [(re-posh/subscribe [:source/pull-many
                        '[* {:source/updated-by [:searchable-user/username]
                             :source/created-by [:searchable-user/username]}]])
    (re-posh/subscribe [:connections.subs/all-connectors])
    (re-posh/subscribe [:mold-http/loading? :connections.api/fetch-user-connectors])
    (re-posh/subscribe [:mold-http/loading? :connections.api/fetch-sources])])
 (fn [[sources connectors connectors-loading? sources-loading?]]
   {:sources             sources
    :connectors          connectors
    :connectors-loading? connectors-loading?
    :sources-loading?    sources-loading?}))

(re-frame/reg-sub
 :connections.subs/deleted-sources-list-view
 (fn [_]
   [(re-posh/subscribe [:deleted-source/pull-many])
    (re-posh/subscribe [:mold-http/loading? :connections.api/fetch-deleted-sources])])
 (fn [[sources sources-loading?]]
   {:deleted-sources             sources
    :deleted-sources-loading?    sources-loading?}))

(re-frame/reg-sub
 :connections.subs/deleted-extracts-list-view
 (fn [_]
   [(re-posh/subscribe [:deleted-extract/pull-many])
    (re-posh/subscribe [:mold-http/loading? :connections.api/fetch-deleted-extracts])])
 (fn [[extracts extracts-loading?]]
   {:deleted-extracts             extracts
    :deleted-extracts-loading?    extracts-loading?}))


(re-frame/reg-sub
 :connections.subs/connector-for-source-id
 (fn [[_ source-id]]
   [(re-posh/subscribe [:connections.subs/all-connectors])
    (re-posh/subscribe [:source/pull [:source/source-id source-id]])])
 (fn [[connectors source]]
   (let [version     (get-in source [:source/source :version])
         source-type (:source/source-type source)]
     (app.utils/find-connector-by-type-and-version connectors source-type version))))


(def property->keyword
  {:catalogs :table-cat
   :schemas  :table-schem})


(re-frame/reg-sub
 :connections.subs/warehouse-meta
 (fn [[_ property]]
   (re-posh/subscribe [:warehouse-meta/prop (keyword "warehouse-meta" property)]))
 (fn [object [_ property]]
   (-> property
       property->keyword
       (map object)
       (sort))))


(re-frame/reg-sub
 :connections.subs/warehouse-db-name
 (fn [_]
   [(re-posh/subscribe [:warehouse-data/prop :warehouse-data/json-data])
    (re-posh/subscribe [:warehouse-data/prop :warehouse-data/sink-type])])
 (fn [[{:keys [db-name]} sink-type]]
   (if (= sink-type "snowflake")
     (clojure.string/upper-case db-name)
     db-name)))

(re-frame/reg-sub
 :connections.subs/format-extract
 (fn [[_ extract-id source-id]]
   [(re-posh/subscribe [:extract/pull [:extract/extract-id extract-id]])
    (re-posh/subscribe [:source/pull [:source/source-id source-id]])
    (re-posh/subscribe [:connections.subs/all-connectors])])
 (fn [[extract source connectors] [_ _ _ data]]
   (let [{:source/keys [source-type]} source
         version (get-in extract [:config :extracts 0 :version])
         connector (app.utils/find-connector-by-type-and-version connectors source-type version)
         form-definition   (:extract-form connector)
         format-for-api    (:format-for-api form-definition)
         format-for-inputs (:format-for-inputs form-definition)]
     (-> extract
         (merge data)
         format-for-inputs
         format-for-api))))

(re-frame/reg-sub
 :connections.subs/failed-statuses-count-for-source
 (fn []
   (re-frame/subscribe [:statuses.subs/failed :extract]))
 (fn [failures [_ source-id]]
   (count (filter #(= (:source-id %) source-id) failures))))
